import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function formatBytes(
	bytes: number,
	opts: {
		decimals?: number
		sizeType?: 'accurate' | 'normal'
	} = {},
) {
	const { decimals = 0, sizeType = 'normal' } = opts

	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
	const accurateSizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB']
	if (bytes === 0) return '0 Byte'
	const i = Math.floor(Math.log(bytes) / Math.log(1024))
	return `${(bytes / Math.pow(1024, i)).toFixed(decimals)} ${
		sizeType === 'accurate'
			? (accurateSizes[i] ?? 'Bytest')
			: (sizes[i] ?? 'Bytes')
	}`
}

export const formatDateTime = (date: string) => {
	return format(new Date(date), 'PPP HH:mm น.', { locale: th })
}

export const formatCurrency = (value: number): string => {
	return `฿${value.toLocaleString('th-TH', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`
}

export const formatUsd = (value: number): string => {
	return `$${value.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`
}

export const formatNumber = (value: number): string => {
	return Math.round(value).toLocaleString('th-TH')
}
